import React from 'react';
import SEOHeadNative from '../components/SEOHeadNative';

const EnseignesLumineuses: React.FC = () => {
  const pdfPath = '/documents/Catalogue_Enseignes_2026.pdf';

  return (
    <div>
      <SEOHeadNative
        title="Enseignes Lumineuses - Catalogue 2026 - OZARKSELEC"
        description="Découvrez notre catalogue d'enseignes lumineuses 2026 : croix de pharmacie, enseignes LED, panneaux lumineux. Installation et maintenance par OZARKSELEC."
        keywords="enseigne lumineuse, croix de pharmacie, LED, panneau lumineux, OZARKSELEC, catalogue 2026"
        canonical="/enseignes"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Enseignes Lumineuses",
          "description": "Installation d'enseignes lumineuses : croix de pharmacie, enseignes LED, panneaux lumineux. Catalogue 2026 disponible.",
          "provider": {
            "@type": "ElectricalContractor",
            "name": "OZARKS ELEC",
            "url": "https://ozarkselec.com"
          },
          "areaServed": ["Aisne", "Thiérache", "Caudrésis", "Catésis", "Nord"],
          "serviceType": "Installation enseignes lumineuses"
        }}
      />

      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px'}}>
        <div className="t-container">
          <div className="t-col t-col_10 t-prefix_1">
            <div className="t-align_center">
              <h1 className="t-title t-title_xs ozarks-blue-dark" style={{marginBottom: '20px'}}>
                Enseignes <span className="ozarks-blue-medium">Lumineuses</span>
              </h1>
              <div className="t-descr t-descr_xl t-margin_auto" style={{marginBottom: '40px', color: 'var(--ozarks-gray)', maxWidth: '600px'}}>
                Consultez notre catalogue 2026 : croix de pharmacie, enseignes LED, panneaux lumineux et bien plus
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Viewer PDF */}
      <div className="r t-rec t-rec_pt_0 t-rec_pb_90" style={{paddingTop: '0', paddingBottom: '90px'}}>
        <div className="t-container">
          <div className="t-col t-col_12">
            <div style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              boxShadow: '0 4px 20px var(--ozarks-shadow)',
              overflow: 'hidden',
              minHeight: '800px'
            }}>
              {/* Contrôles du viewer */}
              <div style={{
                backgroundColor: 'var(--ozarks-light-gray)',
                padding: '15px 20px',
                borderBottom: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '10px'
              }}>
                <h3 style={{
                  color: 'var(--ozarks-blue-dark)',
                  margin: 0,
                  fontSize: '18px',
                  fontWeight: 600
                }}>
                  Catalogue Enseignes Lumineuses 2026
                </h3>
                <a
                  href={pdfPath}
                  download
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    backgroundColor: 'var(--ozarks-blue-dark)',
                    color: 'white',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontWeight: 500,
                    fontSize: '14px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--ozarks-blue-medium)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--ozarks-blue-dark)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                  </svg>
                  Télécharger le catalogue
                </a>
              </div>

              {/* Viewer PDF intégré */}
              <div style={{
                width: '100%',
                height: '800px',
                position: 'relative'
              }}>
                <iframe
                  src={`${pdfPath}#toolbar=1&navpanes=1&scrollbar=1`}
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none'
                  }}
                  title="Catalogue Enseignes Lumineuses 2026"
                />
              </div>
            </div>

            <div style={{
              marginTop: '30px',
              padding: '20px',
              backgroundColor: 'var(--ozarks-light-gray)',
              borderRadius: '10px',
              textAlign: 'center'
            }}>
              <p style={{
                color: 'var(--ozarks-gray)',
                margin: 0,
                fontSize: '14px',
                lineHeight: '1.6'
              }}>
                Pour toute demande de devis ou d'information, n'hésitez pas à nous contacter.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnseignesLumineuses;
